export default {
  10001: 'Por favor ingrese nombre de usuario o correo electrónico',
  10002: 'Correo electrónico ingresado incorrectamente',
  10003: 'error de entrada de nombre de usuario',
  10004: 'Contraseña ingresada incorrectamente',
  10005: 'Estado de usuario anormal',
  10006: 'nombre de usuario ya existe',
  10007: 'el Email ya existe',
  10008: 'El estado del usuario es incorrecto',
  10009: 'No se encontró ningún usuario correspondiente',
  10010: 'El producto del Asesor Experto es incorrecto',
  10011:
    'Si el saldo del usuario es insuficiente, recargue o libere el depósito antes de realizar una compra.',
  10012: 'No se encontraron días correspondientes',
  10013: 'El monto de la inversión es incorrecto',
  10014: 'El producto de liquidación cuantitativa es incorrecto',
  10015: 'Actualmente no disponible para negociar',
  10016: 'Monto de compra incorrecto',
  10017: 'No se encontró ningún período correspondiente',
  10018: 'No se pudieron obtener los parámetros del sistema',
  10019: 'El estado de autenticación actual de este usuario es incorrecto',
  10020: 'El estado de la colección es incorrecto.',
  10021: 'Dirección de recepción no completada',
  10022: 'El usuario no está autenticado',
  10023: 'El período del préstamo está configurado incorrectamente',
  10024: 'Ya compré el mismo producto, no lo vuelvas a comprar.',
  10025: 'Por favor seleccione un método de retiro',
  10027: 'El monto del préstamo no puede estar vacío',
  10028: 'El plazo del préstamo no puede estar vacío',
  10029: 'El monto del préstamo debe ser mayor que 0',
  10030: 'La configuración del plazo del préstamo no existe',
  10031: 'El monto del préstamo está por debajo del valor mínimo',
  10032: 'El monto del préstamo excede el valor máximo',
  10033: 'El ID del registro del préstamo no puede estar vacío',
  10034: 'El registro del préstamo no existe',
  10035: 'No tiene permiso para operar este registro de préstamo',
  10036: 'El estado del préstamo no permite el reembolso',
  10037: 'Saldo insuficiente en la cuenta',
  10108:
    'Acciones de EE. UU. fuera del horario de negociación (lun–vie 9:30–16:00 ET). Inténtelo más tarde.',
  10109: 'Forex/metales preciosos fuera del horario (dom 17:00–vie 17:00 ET). Inténtelo más tarde.',
  10110: 'Cantidad de trading no válida. Introduzca un valor mayor que 0.',
  20001: 'Envío para revisión exitoso',
  20002: 'Recarga agregada exitosamente y enviada para revisión',
  20003: 'Retiro agregado exitosamente y enviado para revisión',
  20004: 'Compra exitosa',
  20005: 'Modificado con éxito',
  20024: 'Ya has comprado el mismo producto, por favor no lo compres de nuevo',
  20102:
    'Su cuenta ha sido congelada. El trading y los retiros no están disponibles temporalmente. Póngase en contacto con soporte si tiene preguntas.',
  20103: 'Su sesión ha expirado. Por favor, inicie sesión de nuevo.',
  20104: 'No ha iniciado sesión. Por favor, inicie sesión.',
  Invite: {
    CopyLink: 'Copiar enlace',
    FillInAccount: 'Completa el formulario en línea y abre una cuenta de comercio',
    Fund: 'Financiar',
    FundYourPrefer:
      'Financia tu cuenta a través de cualquier método de financiamiento que prefieras',
    InviteFriends: 'Invitar amigos',
    InviteYourFriends: 'Invita a tus amigos',
    Register: 'Registrarse',
    StartTradingPlatform: 'Comienza a comerciar con nuestra plataforma de comercio galardonada',
    Trade: 'Comerciar',
    WhenYourRewards:
      'Invita a tus amigos y familiares a unirse a nosotros y juntos cosecharán recompensas mientras emprenden un viaje hacia la prosperidad financiera.',
  },
  Market: {
    CreateAPlanToTrade: 'Crea un plan para operar',
    ETF: 'Fondos cotizados (ETF)',
    ExpectedReturn: 'Rendimiento esperado',
    LastPrice: 'Último precio',
    Lots: 'Lotes',
    OpenPrice: 'Precio de apertura',
    OrderAgain: 'Ordenar de nuevo',
    OrderNumber: 'Número de orden',
    Price: 'Precio',
    Prices: 'Precio...',
    Sizes: 'Tamaño...',
    SpotPrice: 'Precio spot',
    StopLossPrices: 'Precio de stop loss...',
    TakeProfitPrices: 'Precio de take profit...',
    WantMoreStableEarning: 'Quieres ganancias más estables',
    WhatIsSmartTrading: '¿Qué es el trading inteligente?',
    available: 'Disponible',
    buy: 'Comprar',
    buyLong: 'Comprar/Largo',
    buyLongBtn: 'Comprar Largo',
    chart: 'Gráfico',
    checkoutSuccess: 'Compra realizada con éxito',
    close: 'Cierre',
    confirm: 'Confirmar',
    contracts: 'Contratos',
    create: 'Crear',
    cypto: 'Cripto',
    day: 'día',
    down: 'Baja',
    estimation: 'Estimación',
    forex: 'Forex',
    free: 'Comisión',
    frees: 'Gratuito',
    futures: 'Materias primas',
    high: 'Máximo',
    hour: 'hora',
    investment: 'Inversión',
    leverage: 'Apalancamiento',
    limit: 'Límite',
    low: 'Mínimo',
    market: 'Mercado',
    min: 'min',
    mon: 'mes',
    name: 'Nombre',
    notOpen: 'La función aún no está abierta.',
    open: 'Apertura',
    options: 'Liquidación cuantitativa',
    optionsTime: 'Tiempo de liquidación',
    orderConfirm: 'Confirmación del pedido',
    requiredMargin: 'Margen requerido',
    return: 'Retorno',
    sell: 'Vender',
    sellShort: 'Vender/Corto',
    sellShortBtn: 'Vender Corto',
    stocks: 'Acciones',
    stopLoss: 'Stop Loss',
    stopLossPrice: 'Precio de stop loss',
    takeProfit: 'Tomar ganancias',
    takeProfitPrice: 'Precio de toma de ganancias',
    time: 'Hora',
    up: 'Alza',
    volume: 'Volumen',
    watchlist: 'Lista de seguimiento',
    week: 'semana',
  },
  SmartTrading: {
    InterInvestmentAmount: 'Cantidad de inversión intermedia...',
    SelectATimeframe: 'Seleccione un plazo',
    create: 'Crear',
    createAPlan: 'Crear un plan',
    dailyYield: 'Rendimiento diario',
    days: 'Días',
    investment: 'Inversión',
    investmentRange: 'Límite de inversión',
    product: 'Producto',
    smrtTrading: 'Trading inteligente',
    timeframe: 'Plazo',
  },
  aboutUs: {
    about: 'Sobre nosotros',
    subtitle1: 'Perfil de la empresa',
    subtitle2: 'Socio',
    title: 'Acerca de la {title}',
  },
  account: {
    BTCAmount: 'Cantidad',
    LOTS: 'Lotes',
    LastDigits: 'Últimos 6 Dígitos',
    Lots: 'Lotes',
    PaymentAmount: 'Cantidad del Pago',
    PleaseUploadSubmission:
      'Por favor, sube la captura de pantalla de tu pago en criptomoneda y espera la verificación después de enviarla',
    Preview: 'Vista Previa',
    SelectImage: 'Seleccionar Imagen',
    Supports: 'Formatos admitidos: JPG, JPEG2000, PNG',
    TransactionHash: 'Hash de Transacción',
    UploadProof: 'Subir Prueba',
    UploadYourScreenshot: 'Sube la captura de pantalla de tu transferencia',
    accountVerification: 'Verificación de cuenta',
    address: 'Endereço',
    allOrders: 'Todas as ordens',
    amount: 'Quantidade',
    approved: 'Aprovado',
    balance: 'Saldo',
    buy: 'Comprar',
    cancel: 'Cancelar',
    changeLanguage: 'Mudar idioma',
    changePassword: 'Alterar senha',
    close: 'Fechar',
    closePrice: 'Preço de fechamento',
    closeTime: 'Horário de fechamento',
    closed: 'Fechado',
    contactUs: 'Contáctanos',
    copyAddress: 'Copiar endereço',
    copySuccess: 'Copiado exitosamente',
    cycle: 'Ciclo',
    dailyRor: 'Retorno diário',
    demo: 'Demonstração',
    deposit: 'Depósito',
    depositWithdraw: 'Depositar e sacar',
    down: 'Baixa',
    downloadPDF: 'Baixar PDF',
    earlyExist: 'Saída antecipada',
    earlyExit: 'Salida temprana',
    earlyExitTip:
      'Si la transacción se detiene temprano, el sistema deducirá automáticamente {num} del capital como indemnización y se deducirá su ingreso total.',
    expandMore: 'Expandir mais',
    expirationTime: 'Horário de expiração',
    failed: 'Fallido',
    freeMargin: 'Margem usada',
    futures: 'Futuros',
    helpCenter: 'Centro de ayuda (Preguntas frecuentes)',
    inviteFriends: 'Invita a tus amigos',
    lastPrice: 'Último preço',
    lever: 'Alavancagem',
    liquidatedDamages: 'Danos liquidadas',
    loan: 'Empréstimo',
    logOut: 'Cerrar sesión',
    logoutConfirm: '¿Está seguro de que desea cerrar sesión?',
    margin: 'Lucro esperado',
    myAccount: 'Minha conta',
    notification: 'Notificación',
    notifications: 'Notificações',
    okay: 'Okay',
    open: 'Abrir',
    openPrice: 'Preço de abertura',
    openTime: 'Horário de abertura',
    options: 'Liquidación cuantitativa',
    optionsOrder: 'Orden de liquidación cuantitativa',
    order: 'Ordem',
    pips: 'Pips',
    profit: 'Lucro',
    putAway: 'Arrumar',
    receiveAddress: 'Endereço de recebimento',
    recreatePlan: 'Recrear plan',
    refund: 'Reembolso',
    refundTip: 'Os fundos serão reembolsados ​​em sua conta ativa, verifique-a.',
    repayNow: 'Pagar agora',
    repayment: 'Pagamento',
    repaymentAmount: 'Valor do reembolso',
    repaymentDate: 'Data de reembolso',
    repeatOrder: 'Repetir esta ordem',
    reviewed: 'A ser revisado',
    runTime: 'Tempo de execução',
    save: 'Salvar',
    sell: 'Vender',
    settings: 'Ajustes',
    smart: 'Inteligente',
    startTime: 'Horário de início',
    staticincome: 'Ingresos estáticos',
    status: 'Status',
    success: 'Éxito',
    time: 'Tiempo',
    todayEarnings: 'Ganhos de hoje',
    todayProfit: 'Lucro de hoje',
    totalInterest: 'Juros totais',
    totalProfit: 'Lucro total',
    totalRepayment: 'Pagamento total',
    totalRevenue: 'Receita total',
    transFees: 'Tarifas de transação',
    transRecord: 'Registro de transações',
    transaction: 'Transação',
    type: 'Tipo',
    up: 'Alta',
    withdraw: 'Retirar',
    withdrawNow: 'Retirar agora',
  },
  bangZhuZhongXin: 'Centro de ayuda',
  biaoDian: 'puntuación',
  board: {
    content:
      'Este software satisface todas sus necesidades de manera profesional con la mejor tecnología',
    continue: 'Continuar',
    skip: 'Saltar',
    title: 'La mejor plataforma de negociación',
  },
  bread: {
    introduction: 'Introducción',
  },
  chaKan: 'Controlar',
  chongZhi: 'completar',
  chongZhiJinexiaoYuZuiDiChongZhiJinE:
    'El monto de recarga es menor que el monto mínimo de recarga',
  chongZhiPingZheng: 'Bono de recarga',
  chongZhiShiJian: 'Tiempo de recarga',
  chongZhiShuoMing: 'Instrucciones de recarga:',
  chongZhiShuoMingUsdtZuiDiChongZhiJinewei_120btcZuiDiChongZhiJinewei_0015ethZuiDiChongZhiJinewei_02:
    'Instrucciones de depósito: el monto mínimo de depósito para USDT es 120, el monto mínimo de depósito para BTC es 0,015 y el monto mínimo de depósito para ETH es 0,2',
  close: 'Cerrar',
  'customerService.error':
    'El servicio de atención al cliente no está disponible temporalmente. Inténtalo más tarde.',
  'customerService.close': 'Cerrar',
  'customerService.connected': 'Conectado',
  'customerService.imageAlt': 'Imagen de atención al cliente',
  'customerService.imagePreview': 'Vista previa de la imagen',
  'customerService.imageTooLarge': 'La imagen no puede superar los 5 MB',
  'customerService.imageTypeUnsupported': 'Solo se admiten imágenes PNG, JPEG o WebP',
  'customerService.imageUnavailable': 'Imagen no disponible',
  'customerService.loadFailed':
    'No se pudo cargar el servicio de atención al cliente en línea. Inténtalo más tarde.',
  'customerService.loading': 'Cargando…',
  'customerService.loginRequired': 'Inicia sesión para contactar con soporte',
  'customerService.openImage': 'Abrir imagen',
  'customerService.placeholder': 'Escribe un mensaje, pulsa Enter para enviar',
  'customerService.send': 'Enviar',
  'customerService.sendImage': 'Enviar imagen',
  'customerService.reconnecting': 'Reconectando',
  'customerService.title': 'Soporte',
  daDuoShuWangZhanDuHuiCaiQuCuoShiBaoHuYongHuDeGeRenXinXiLiRuShiYongJiaMiJiShuLaiBaoHuMiMa:
    'La mayoría de los sitios web toman medidas para proteger la información personal de los usuarios, como el uso de tecnología de cifrado para proteger las contraseñas.',
  daDuoShuWangZhanDuYunXuYongHuGengGaiTaMenDeGeRenXinXiLiRuGengGaiDianZiYouJianDiZhiHuoMiMaDanShiMouXieXinXiKeNengWuFaGengGaiLiRuYongHuMing:
    'La mayoría de los sitios web permiten a los usuarios cambiar su información personal, como cambiar su dirección de correo electrónico o contraseña. \nSin embargo, es posible que cierta información no se pueda cambiar, como el nombre de usuario.',
  daiKuanHou_3TianNeiWuXuZhiFuLiXi_3TianHouXuZhiFuLiXi:
    'No se requieren intereses dentro de {num} días después de la obtención del préstamo y los intereses se pagarán después de {num} días.',
  daiShenHe: 'Revisión pendiente',
  danShiRuGuoNinShiYongDeWangZhanHuoYingYongChengXuCunZaiAnQuanLouDongNinDeGeRenXinXiKeNengHuiBeiXieLou:
    'Sin embargo, si el sitio web o la aplicación que utiliza tiene una vulnerabilidad de seguridad, su información personal puede quedar expuesta.',
  dangQiLiRun: 'Beneficio del período actual',
  dangQianLiXi: 'interés actual',
  daoQiHuanXiHuanBen: 'Pagar intereses y capital a su vencimiento',
  daoQiShiJian: 'Fecha de caducidad',
  dengLuChengGong: 'Inicio de sesión correcto',
  di: 'Bajo',
  dianHuaHaoMa: 'número de teléfono:',
  dieJiaLiShuai: 'Tasa de interés superpuesta:',
  el: {
    cascader: {
      loading: 'Loading',
      noData: 'No data',
      noMatch: 'No matching data',
      placeholder: 'Select',
    },
    colorpicker: {
      clear: 'Clear',
      confirm: 'OK',
    },
    datepicker: {
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      endDate: 'End Date',
      endTime: 'End Time',
      month1: 'January',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      months: {
        apr: 'Apr',
        aug: 'Aug',
        dec: 'Dec',
        feb: 'Feb',
        jan: 'Jan',
        jul: 'Jul',
        jun: 'Jun',
        mar: 'Mar',
        may: 'May',
        nov: 'Nov',
        oct: 'Oct',
        sep: 'Sep',
      },
      nextMonth: 'Next Month',
      nextYear: 'Next Year',
      now: 'Now',
      prevMonth: 'Previous Month',
      prevYear: 'Previous Year',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      today: 'Today',
      week: 'week',
      weeks: {
        fri: 'Fri',
        mon: 'Mon',
        sat: 'Sat',
        sun: 'Sun',
        thu: 'Thu',
        tue: 'Tue',
        wed: 'Wed',
      },
      year: '',
    },
    empty: {
      description: 'No Data',
    },
    image: {
      error: 'FAILED',
    },
    messagebox: {
      cancel: 'Cancel',
      confirm: 'OK',
      error: 'Illegal input',
      title: 'Message',
    },
    pageHeader: {
      title: 'Back',
    },
    pagination: {
      goto: 'Go to',
      pageClassifier: '',
      pagesize: '/page',
      total: 'Total {total}',
    },
    popconfirm: {
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
    },
    select: {
      loading: 'Loading',
      noData: 'No data',
      noMatch: 'No matching data',
      placeholder: 'Select',
    },
    table: {
      clearFilter: 'All',
      confirmFilter: 'Confirm',
      emptyText: 'No Data',
      resetFilter: 'Reset',
      sumText: 'Sum',
    },
    transfer: {
      filterPlaceholder: 'Enter keyword',
      hasCheckedFormat: '{checked}/{total} checked',
      noCheckedFormat: '{total} items',
      noData: 'No data',
      noMatch: 'No matching data',
      titles: ['List 1', 'List 2'],
    },
    tree: {
      emptyText: 'No Data',
    },
    upload: {
      continue: 'Continue',
      delete: 'Delete',
      deleteTip: 'press delete to remove',
      preview: 'Preview',
    },
  },
  gao: 'alto',
  gouMai: 'Comprar',
  gouMaiChengGong: 'Compra exitosa',
  guoJiHuoBiZhangHuLianXiZaiXianZhiChiFuWuJinHangPiPei:
    'Las cuentas en moneda internacional se comunican con los servicios de soporte en línea para igualar',
  home: {
    Application: 'Aplicación',
    AvailableOnThe: 'Disponible en la',
    CreditCard: 'Depósito de criptomonedas',
    CreditCardInfo:
      'Al usar criptomonedas para el depósito, se obtiene una capa adicional de seguridad y se garantiza un procesamiento rápido de la transacción.',
    CryptocurrenciesListed: 'Criptomonedas listadas',
    GetStarted: 'Empezar',
    NewFeaturesInOnline: 'Nuevas características en línea',
    NewFeaturesInOnlineInfo: 'Conoce las maravillosas características de esta plataforma completa',
    RegisteredUsers: 'Usuarios registrados',
    allChains: 'All Chains',
    announcementClose: 'Cerrar aviso',
    announcementLabel: 'Aviso',
    announcementView: 'Ver detalles',
    announcementAmount: 'Importe prestado',
    announcementAnnualRate: 'Rendimiento anual',
    announcementBelowMinimum: 'Menos de {amount} USDT',
    announcementCompoundInterest: 'Interés compuesto',
    announcementCurrentConfig: 'Configuración actual',
    announcementEarningMode: 'Método de interés',
    announcementRateNotice:
      'Las ganancias siguen los tramos actuales de la plataforma. Los importes finales aparecen en Activos y en los registros de liquidación.',
    announcementRatesLoading: 'Cargando los tramos de rendimiento…',
    announcementSettlement: 'Horas de liquidación diaria',
    announcementSimpleInterest: 'Interés simple',
    announcementYieldEyebrow: 'Información de rendimiento',
    announcementYieldIntro:
      'Los importes prestados más altos reciben un mayor rendimiento anual. Los importes inferiores al primer tramo pueden participar, pero no generan intereses.',
    announcementYieldTitle: 'Detalles del rendimiento actual',
    appLicationInfo:
      'Banca móvil que descarta el libro de normas y te brinda una herramienta precisa para administrar tus finanzas.',
    billion: 'B',
    billionInfo: 'Volumen de operaciones promedio de 24 horas',
    button1Title: 'Tarifas de transacción más bajas',
    button1Title1: 'Tradea activos en un sitio',
    button1Title2: 'Forex, criptomonedas, acciones, índices, materias primas',
    button2Title: 'Bajo interés y monto más alto',
    button2Title1: 'Préstamos de criptomonedas',
    button2Title2: 'Borrow cryptocurrency spots without any collateral',
    button3Title: 'Simple y estable',
    button3Title1: 'Operaciones inteligentes',
    button3Title2: 'Un clic para crear su plan de ganancias',
    button4Title: 'Ayuda a los niños de todo el mundo',
    button4Title1: 'Caridad de NFT',
    button4Title2: 'Compre obras de arte de NFT para apoyar a UNICEF',
    closeFeatured: 'Close featured',
    colApy: 'APY',
    colAsset: 'Asset',
    colChain: 'Chain',
    colTotalDeposits: 'Total Deposits',
    depositAction: 'Deposit',
    depositSubtitle: 'Proporcione liquidez al pool de préstamos para ganar intereses',
    depositTitle: 'Defi Lending Pool',
    featured: 'Featured',
    filterAssets: 'Filter assets...',
    homeTitle: 'Compra, intercambia y guarda 350+ criptos en la plataforma top.',
    loading: 'Loading...',
    million: 'M',
    noMore: 'No more pools',
    noPools: 'No lending pools yet',
    noticeInfo: 'La cartera puede cambiar BTC por USD',
    noticeInfo1: 'Operar con una cuenta de demostración',
    periodDays: '{count} day | {count} days',
    sortApy: 'Sort: APY',
    sortTotalDeposits: 'Sort: Total Deposits',
  },
  huanKuanZhong: 'Pago en curso',
  huanYingShiYongWoMenLvHuoShuRongDeJinRongJiaoYiPingTaiYuQuanQiuTouZiZheYiQiTanSuoWeiLaiDeJinRongShiJie:
    '¡Bienvenido a utilizar nuestra galardonada plataforma de comercio financiero y explorar el futuro mundo financiero con inversores globales!',
  jiXiShiJian: 'Tiempo de acumulación de intereses',
  jiXuTouZi: 'Sigue invirtiendo',
  jiangTuPianTuoFangDaoCiChuHuo: 'Arrastre y suelte una imagen aquí, o',
  jieZhiShiJian: 'fecha límite',
  jiuMiMa: 'Contraseña anterior',
  juJueYuanYin: 'Motivo del rechazo',
  kai: 'abierto',
  lendingAssets: {
    authorizedBalance: 'Saldo autorizado',
    availableAmount: 'Disponible para retirar',
    dailyOrders: 'Ordenes de liquidacion diarias',
    dailyProfit: 'Ganancia diaria',
    joinPool: 'Unirse al pool',
    loadMore: 'Cargar mas',
    needAuth: 'Unete a un pool de prestamos para ver saldos y ganancias',
    needLogin: 'Inicia sesion para ver tus activos',
    noOrders: 'Aun no hay ordenes de liquidacion',
    pageDesc: 'Consulta saldos autorizados, ganancias del pool y ordenes de liquidacion diarias',
    poolEarnings: 'Ganancias del pool de prestamos',
    todayEarnings: 'Hoy',
    totalEarnings: 'Ganancias totales',
    withdraw: 'Retirar',
    withdrawRecords: 'Historial de retiros',
    withdrawnAmount: 'Ya retirado',
  },
  lendingContent: {
    rulesSecurity:
      "<p>This page describes <strong>interest accrual rules, settlement cadence, and security mechanisms</strong> for the lending pool. Please read carefully before participating.</p>\n\n<h2>1. Interest Rules</h2>\n<h3>1.1 Accrual Base</h3>\n<p>Earnings accrue on your <strong>authorized on-chain balance</strong> after Approve. Once authorized, the system reads your USDT / USDC (and other supported asset) allowance and balance as the principal reference for each settlement period.</p>\n\n<h3>1.2 Interest Rate</h3>\n<p>Settlement rates reference the associated pool's <strong>Supply APY</strong>, updated as on-chain market data syncs. APY includes base and reward components; the rate effective for each period applies at settlement time.</p>\n\n<h3>1.3 Settlement Cadence</h3>\n<ul>\n  <li><strong>Frequency:</strong> A yield settlement order is generated once daily;</li>\n  <li><strong>Order type:</strong> Period earnings (viewable under My Portfolio → Settlement Orders);</li>\n  <li><strong>Fields shown:</strong> Amount, token type (USDT / USDC), settlement time.</li>\n</ul>\n<p>Approximate daily amount ≈ Authorized balance × APY ÷ 365 (daily proration). Very small amounts may round to zero.</p>\n\n<h3>1.4 Total &amp; Today</h3>\n<p><strong>Total Earnings</strong> is the sum of historical settlements. <strong>Today</strong> reflects settlements from 00:00 to now (server time). Figures are based on system order records.</p>\n\n<h2>2. Authorization &amp; Security</h2>\n<h3>2.1 Non-Custodial</h3>\n<p>This service is <strong>non-custodial</strong>: we do not store private keys, seed phrases, or credentials that can move funds directly. All on-chain authorization requires confirmation in your wallet.</p>\n\n<h3>2.2 Authorization Scope</h3>\n<p>Joining a pool requires ERC-20 <strong>Approve</strong>, allowing the protocol contract to interact within your allowance. You should:</p>\n<ul>\n  <li>Confirm only authorization requests initiated from the official UI;</li>\n  <li>Periodically review and revoke unused approvals in your wallet;</li>\n  <li>Never approve unknown addresses or phishing sites.</li>\n</ul>\n\n<h3>2.3 Account &amp; API Security</h3>\n<ul>\n  <li>Client APIs use token authentication; sensitive actions require an active session;</li>\n  <li>Full-site HTTPS encryption;</li>\n  <li>Authorization and settlement records are retained for audit and queries.</li>\n</ul>\n\n<h2>3. On-Chain Protocol Security</h2>\n<ul>\n  <li>Underlying protocols use audited open-source smart contracts; deposit, borrow, and liquidation run on-chain;</li>\n  <li>Over-collateralization and liquidation help maintain solvency;</li>\n  <li>Pool TVL, APY, and utilization data from public sources may lag on-chain state by minutes.</li>\n</ul>\n\n<h2>4. User Responsibilities</h2>\n<ul>\n  <li>DeFi yields fluctuate; <strong>fixed returns are not guaranteed</strong>;</li>\n  <li>Stablecoins may de-peg under extreme conditions;</li>\n  <li>Network congestion may delay authorization or queries;</li>\n  <li>Never share private keys, seed phrases, or verification codes;</li>\n  <li>Stop immediately and contact support if you see suspicious links or approval prompts.</li>\n</ul>\n\n<h2>5. Revocation &amp; Exit</h2>\n<p>You may set token allowance to <strong>zero in your wallet</strong> to revoke Approve at any time. No new period earnings accrue after revocation; historical settlements remain queryable. Revocation does not change on-chain asset ownership—funds remain in your wallet address.</p>\n\n<p>— If rules change, the latest client display and settlement records prevail.</p>",
    whitepaper:
      '<p><strong>Versión del documento:</strong> V3.28 &nbsp;|&nbsp; <strong>Fecha de publicación:</strong> 2022 &nbsp;|&nbsp; <strong>Tipo:</strong> Whitepaper del producto y resumen de evaluación de seguridad</p>\n\n<h2>1. Resumen ejecutivo</h2>\n<p>Este módulo Lending Pool es un servicio de préstamo y liquidez on-chain basado en protocolos DeFi de mercado monetario. Mediante smart contracts de código abierto y modelos de tipos programáticos, el sistema conecta los activos digitales de los usuarios con mercados de préstamo on-chain consolidados, permitiendo <strong>rendimiento en depósitos, préstamos colateralizados y liquidez compartida</strong>.</p>\n<p>El módulo no depende de intervención manual para la asignación diaria de fondos. Las tasas, capacidades y utilización se determinan en tiempo real por los mercados on-chain y se muestran de forma transparente mediante agregación de datos multi-fuente.</p>\n\n<h2>2. Contexto del sector y posicionamiento</h2>\n<p>El crédito tradicional depende de instituciones centralizadas. Los protocolos DeFi utilizan smart contracts para emparejar automáticamente oferta y demanda, con sobrecolateralización y mecanismos de liquidación.</p>\n<p>Posicionamiento de este módulo:</p>\n<ul>\n  <li><strong>Puerta de entrada a mercados monetarios on-chain:</strong> agrega datos de pools en múltiples cadenas y protocolos;</li>\n  <li><strong>Distribución programática de rendimientos:</strong> liquidación automática según calendario fijo basado en saldos autorizados y APY de mercado;</li>\n  <li><strong>Transparente y verificable:</strong> TVL, APY, utilización y LTV trazables a datos on-chain públicos;</li>\n  <li><strong>No custodial:</strong> la autorización e interacciones on-chain se inician desde la wallet del usuario.</li>\n</ul>\n\n<h2>3. Arquitectura del sistema</h2>\n<h3>3.1 Visión general</h3>\n<ul>\n  <li><strong>Capa de interfaz:</strong> conexión de wallet, autorización, exploración de pools, consulta de ganancias;</li>\n  <li><strong>Capa de servicios:</strong> autenticación, gestión de autorizaciones, órdenes de rendimiento, contenido multilingüe;</li>\n  <li><strong>Capa de agregación:</strong> sincronización programada desde fuentes DeFi públicas;</li>\n  <li><strong>Capa de protocolo on-chain:</strong> smart contracts de préstamo auditados ejecutan depósitos y préstamos.</li>\n</ul>\n\n<h3>3.2 Métricas clave</h3>\n<table>\n  <thead>\n    <tr><th>Métrica</th><th>Descripción</th></tr>\n  </thead>\n  <tbody>\n    <tr><td>TVL</td><td>Activos totales del pool en USD</td></tr>\n    <tr><td>Supply APY</td><td>Rendimiento anual de depósitos (tasa base + recompensas)</td></tr>\n    <tr><td>Borrow APY</td><td>Coste anual pagado por prestatarios</td></tr>\n    <tr><td>Tasa de utilización</td><td>Proporción de fondos prestados sobre disponibles</td></tr>\n    <tr><td>Max LTV</td><td>Ratio préstamo/valor máximo antes de liquidación</td></tr>\n    <tr><td>Supply / Borrow Cap</td><td>Límites por activo para controlar riesgo de concentración</td></tr>\n    <tr><td>Liquidez disponible</td><td>Liquidez inmediatamente prestable</td></tr>\n  </tbody>\n</table>\n\n<h2>4. Flujo de usuario y mecánica de rendimiento</h2>\n<ol>\n  <li><strong>Conectar wallet</strong> vía Web3;</li>\n  <li><strong>Autorizar activos</strong> (USDT, USDC, etc.) con Approve on-chain;</li>\n  <li><strong>Unirse al lending pool</strong> para entrar en la cola de cálculo de rendimientos;</li>\n  <li><strong>Liquidación de rendimientos</strong> diaria según saldo autorizado y tasas de mercado;</li>\n  <li><strong>Consultar activos</strong> en «Mi cartera».</li>\n</ol>\n<p><strong>El APY histórico no garantiza rendimientos futuros.</strong></p>\n\n<h3>4.3 Comisiones</h3>\n<h4>¿Cómo se cobran las comisiones de DeFi Earn?</h4>\n<p>Las transacciones on-chain requieren comisiones de gas para interactuar con smart contracts, incluida la suscripción y el cobro de rendimientos. Para ciertos activos, el lending pool DeFi y los gestores de vault pueden cobrar una comisión de rendimiento como porcentaje de sus beneficios reales; el capital no se ve afectado.</p>\n\n<h2>5. Diseño de seguridad</h2>\n<ul>\n  <li>Protocolos subyacentes con contratos auditados de código abierto;</li>\n  <li>Arquitectura no custodial; sin almacenamiento de claves privadas;</li>\n  <li>Permisos Token Approve mínimos; revocables en cualquier momento;</li>\n  <li>Auth por token, HTTPS, RBAC administrativo y registros de auditoría.</li>\n</ul>\n\n<h2>6. Resumen de evaluación de seguridad</h2>\n<table>\n  <thead>\n    <tr><th>Elemento</th><th>Resultado</th><th>Notas</th></tr>\n  </thead>\n  <tbody>\n    <tr><td>Dependencias de smart contract</td><td><strong>Aprobado</strong></td><td>Protocolos DeFi auditados públicamente</td></tr>\n    <tr><td>No custodial y gestión de claves</td><td><strong>Aprobado</strong></td><td>Sin almacenamiento de claves privadas</td></tr>\n    <tr><td>API y autenticación</td><td><strong>Aprobado</strong></td><td>Auth token y HTTPS implementados</td></tr>\n    <tr><td>Sincronización de datos</td><td><strong>Aprobado</strong></td><td>Sync programada con snapshots</td></tr>\n    <tr><td>Lógica de liquidación de rendimientos</td><td><strong>Aprobado</strong></td><td>Reglas explícitas; órdenes auditables</td></tr>\n  </tbody>\n</table>\n\n<h2>7. Divulgación de riesgos</h2>\n<ul>\n  <li><strong>Riesgo de smart contract:</strong> pueden existir vulnerabilidades no descubiertas;</li>\n  <li><strong>Riesgo de mercado:</strong> el APY puede fluctuar significativamente;</li>\n  <li><strong>Riesgo de liquidación:</strong> caídas del colateral pueden activar liquidación;</li>\n  <li><strong>Riesgo de de-peg de stablecoins:</strong> USDT/USDC pueden desviarse de $1,00;</li>\n  <li><strong>Riesgo regulatorio:</strong> la regulación DeFi evoluciona globalmente.</li>\n</ul>\n<p><strong>Este módulo no proporciona asesoramiento de inversión ni garantiza rendimientos fijos.</strong></p>\n\n<h2>8. Glosario</h2>\n<ul>\n  <li><strong>APY:</strong> rendimiento porcentual anual;</li>\n  <li><strong>TVL:</strong> valor total bloqueado;</li>\n  <li><strong>LTV:</strong> ratio préstamo/valor;</li>\n  <li><strong>Approve:</strong> autorización de token ERC-20;</li>\n  <li><strong>Liquidación:</strong> venta automática de colateral por subcolateralización.</li>\n</ul>\n\n<p>— Solo con fines informativos. No constituye asesoramiento legal, financiero o de inversión. Verifique los datos on-chain mediante exploradores de bloques e interfaces oficiales de protocolos.</p>',
    yieldLadder:
      "<p><strong>Defi Lending Pool</strong> offers a transparent, tiered yield program for authorized stablecoin deposits. Your daily earnings are determined by your authorized balance (USD equivalent) and the applicable tier rate shown below. Tier rates are loaded from the platform configuration in real time.</p>\n\n<h2>1. How Yield Works</h2>\n<p>After you authorize USDT or USDC through your Web3 wallet on <strong>Defi Lending Pool</strong>, the platform uses your on-chain authorized balance as the yield base. Each calendar day, the system generates settlement orders based on the rules below (USDT and USDC are calculated and compounded separately):</p>\n<ul>\n  <li><strong>On-chain principal:</strong> Your authorized stablecoin balance at settlement time (USD equivalent);</li>\n  <li><strong>Tier rate:</strong> The daily yield rate matching your on-chain balance range in the tier table below;</li>\n  <li><strong>Compound mode (default):</strong> Daily earnings ≈ (On-chain balance + accumulated unredeemed earnings for that token) × Daily rate ÷ 100;</li>\n  <li><strong>Simple mode (if enabled):</strong> Daily earnings ≈ On-chain balance × Daily rate ÷ 100.</li>\n</ul>\n<p>Withdrawing platform earnings only affects your withdrawable balance and compound base — <strong>it does not change your on-chain wallet balance</strong>. Settlement runs <strong>4 times per day</strong>. Earnings accumulate in your account and can be viewed under <strong>Assets → Settlement Orders</strong>. Past performance does not guarantee future returns.</p>\n\n<h2>2. Yield Tier Table</h2>\n<p>The table below shows the current tier structure on <strong>Defi Lending Pool</strong>. Higher authorized balances qualify for higher indicative daily rates. Figures are <strong>daily percentages</strong>, not annualized APY.</p>\n<!-- YIELD_TIER_TABLE -->\n<p><strong>Note:</strong> Your tier is determined automatically by your <strong>on-chain authorized balance</strong> at each daily settlement. If your on-chain balance moves into a different range, the next settlement will apply the corresponding tier rate. In compound mode, accumulated unredeemed earnings participate in yield calculation but do not change tier matching.</p>\n\n<h2>3. Tier Matching Rules</h2>\n<ul>\n  <li>Only <strong>authorized (Approved)</strong> USDT / USDC balances participate in yield calculation;</li>\n  <li>Balances below the minimum tier threshold do not generate settlement orders;</li>\n  <li>Each tier applies to a closed USD balance range — the system matches the single tier that contains your balance;</li>\n  <li>Where a tier shows a rate range, settlement uses the midpoint of that range;</li>\n  <li>Tier configuration may be updated by platform operators; changes apply to future settlements only.</li>\n</ul>\n\n<h2>4. Settlement &amp; Display</h2>\n<h3>4.1 Settlement Cycle</h3>\n<ul>\n  <li><strong>Frequency:</strong> Four settlement orders per day per authorized asset;</li>\n  <li><strong>First settlement:</strong> Wallets authorized on the same day begin earning from the next calendar day;</li>\n  <li><strong>Order fields:</strong> Settlement amount, token type (USDT / USDC), applied rate, and timestamp.</li>\n</ul>\n<h3>4.2 Portfolio Metrics</h3>\n<p>On the <strong>Assets</strong> page you can track <strong>Total Earnings</strong> (historical sum) and <strong>Today's Earnings</strong> (current-day settlements). All figures are based on system order records.</p>\n\n<h2>5. Getting Started on Defi Lending Pool</h2>\n<ol>\n  <li>Log in and connect your Web3 wallet (MetaMask or compatible);</li>\n  <li>Tap <strong>Join Now</strong> in the sidebar and choose USDT or USDC;</li>\n  <li>Confirm the on-chain <strong>Approve</strong> transaction in your wallet;</li>\n  <li>Once authorized, your balance is matched to a yield tier automatically;</li>\n  <li>Check daily settlement orders and cumulative earnings on the <strong>Assets</strong> page.</li>\n</ol>\n\n<h2>6. Risk Disclosure</h2>\n<p><strong>Defi Lending Pool</strong> operates in a non-custodial model — the platform never holds your private keys. On-chain authorization carries smart-contract and market risks. Tier rates, pool capacity, and settlement outcomes may change. Please review the <strong>Rules &amp; Security</strong> page before participating.</p>\n\n<p>— Tier rates are synced from platform settings. Table values are indicative; final amounts appear in your settlement order history.</p>",
  },
  lendingDetail: {
    assetOn: 'Asset on',
    availableLiquidity: 'Available Liquidity',
    avgApy30d: '30d Avg APY',
    baseApy: 'Base APY',
    baseRates: 'Base Rates',
    borrow: 'Borrow',
    borrowDesc: 'Borrow {symbol} against your deposited collateral',
    borrowHint: 'Borrow via',
    borrowMarkets: 'Borrow Markets',
    borrowSoon: 'On-chain borrow coming soon',
    capacityFilled: 'Capacity Filled',
    chain: 'Chain',
    chains: 'Chains',
    collateral: 'Collateral',
    deposit: 'Deposit',
    depositApy: 'Deposit APY',
    depositDesc: 'Deposit {symbol} to earn yield',
    depositMarkets: 'Deposit Markets',
    depositSoon: 'On-chain deposit coming soon',
    exposure: 'Exposure',
    loading: 'Loading...',
    notEligible: 'Not eligible',
    notFound: 'Lending pool not found',
    protocol: 'Protocol',
    rewardApy: 'Reward APY',
    stablecoin: 'Stablecoin',
    stablecoinPrice: 'About $1.00',
    title: 'Pool Detail',
    totalDeposits: 'Total Deposits',
  },
  lendingIdentity: {
    needLogin: 'Inicia sesión antes de la verificación de identidad',
    needVerifyHint: 'Completa la verificación de identidad antes de unirte al pool de préstamos',
    pageDesc: 'Completa la verificación de identidad para unirte al pool de préstamos',
    pendingHint: 'Tu verificación de identidad está en revisión. Por favor espera',
  },
  lendingMenu: {
    assets: 'Activos',
    chooseDepositAsset: 'Elige un activo para depositar',
    chooseDepositHint:
      'Deposita activos en un pool de préstamos para obtener rendimiento y habilitar préstamos',
    copyUid: 'Copiar UID',
    customerService: 'Customer Service',
    depositAssetAction: 'Depositar {symbol}',
    earnings: 'Cómo ganar',
    empty: 'Sin contenido',
    explore: 'Explorar',
    footerDesc:
      'Un mercado monetario on-chain de nueva generación construido sobre contratos inteligentes de código abierto. Las reglas programáticas sustituyen el control manual, ofreciendo a usuarios Web3 de todo el mundo servicios seguros y transparentes de depósito y préstamo de liquidez.',
    getStarted: 'Unirse ahora',
    home: 'Inicio',
    identityVerification: 'Verificación de identidad',
    intro: 'Acerca de',
    language: 'Idioma',
    noAssetPool: 'No se encontró un pool de préstamos para este activo',
    rulesSecurity: 'Rules & Security',
    security: 'Seguridad',
    theme: 'Apariencia',
    uid: 'UID',
    whitepaper: 'Whitepaper',
    yieldLadder: 'Niveles de rendimiento',
  },
  lendingTheme: {
    auto: 'Sistema',
    dark: 'Oscuro',
    light: 'Claro',
    title: 'Apariencia',
  },
  lendingYieldLadder: {
    balance: 'Capital de cada préstamo (USDT)',
    compoundInterest: 'Interés compuesto',
    earningMode: 'Modo de rendimiento: {mode}',
    empty: 'Aún no hay niveles configurados',
    loading: 'Cargando tasas por nivel…',
    noteFixed: 'Liquidación diaria a la tasa fija de este nivel',
    noteRange: 'Liquidación diaria por el límite superior del intervalo',
    notes: 'Notas',
    rate: 'Intervalo de rendimiento diario',
    settlementHours: 'Horarios de liquidación configurados: {hours}',
    simpleInterest: 'Interés simple',
  },
  liangCiMiMaBuYiZhi: 'Dos contraseñas son inconsistentes',
  loan: {
    Browse: 'Procurar',
    address: 'Endereço:',
    birthdate: 'Data de nascimento:',
    borrow: 'Pedir prestado',
    borrowNow: 'Pedir prestado ahora',
    borrowPlaceholder: 'Quiero pedir prestado...',
    browse: 'procurar',
    checkIn: 'Envio bem-sucedido',
    confirm: 'Confirmar',
    continue: 'Continuar',
    country: 'País:',
    dailyRate: 'Tasa de interés diaria',
    days: 'Días',
    document: 'Documento:',
    done: 'Feito!',
    driverLicense: 'licencia de conducir',
    dropHere: 'Solte sua imagem aqui',
    ensure: 'Confirmar',
    female: 'Feminino',
    firstName: 'Nome:',
    idCard: 'cartão de identificação',
    inHand: 'em mãos',
    lastName: 'Sobrenome:',
    launchCamera: 'Abrir câmera',
    loanAgreement: 'Contrato de préstamo',
    loanAmount: 'Cantidad del préstamo',
    loanDetail: 'Detalles del préstamo',
    loanTerm: 'Plazo del préstamo',
    male: 'Masculino',
    notVerifyBtn: 'Comenzar verificación',
    notVerifyTip: '¡Verifique su identidad y obtenga más cantidad de préstamo!',
    or: 'ou',
    passport: 'passaporte',
    pendingReview: 'Revisão pendente',
    phone: 'Número de telefone:',
    phonePlaceholder: 'Insira o número do seu telefone...',
    reSign: 'Re-firmar',
    resubmit: 'Reenviar',
    sex: 'Feminino / Masculino:',
    sign: 'Firmar',
    signTip: 'Por favor, confirme y firme',
    signed: 'Assinado',
    startVerfication: 'Iniciar verificação',
    submit: 'Enviar',
    supports: 'Formatos suportados: JPG, JPEG2000, PNG',
    takePhoto: 'Tirar foto',
    term: 'Plazo del préstamo (días)',
    tipIdCardBack: 'Coloque a parte de trás do cartão de identificação no quadro',
    tipIdCardFront: 'Coloque a frente do cartão de identificação no quadro',
    tipNotPass:
      'Pedimos desculpas pelo fato de sua aplicação KYC não ter passado pelo processo de verificação. Por favor, reenvie os materiais de aplicação corretos para completar a verificação KYC. Se tiver alguma dúvida ou precisar de assistência, não hesite em entrar em contato com nossa equipe de atendimento ao cliente a qualquer momento.',
    tipTakePhoto: 'Por favor, tire uma foto com o seu',
    tipVerifiedSuccess:
      'Parabéns! Sua aplicação KYC foi verificada e agora você pode desfrutar de serviços de nível superior.',
    tipWaitForResult:
      'Obrigado por enviar a documentação KYC. Nossa equipe irá rever suas informações em até 48 horas. Por favor, tenha paciência enquanto aguarda os resultados.',
    title: 'Cuenta de préstamos',
    totalAmount: 'Cantidad total de intereses',
    verifiedSuccessfully: 'Verificado com sucesso',
    verifiedUnsuccessfully: 'Verificação mal sucedida',
    verifyBtn: 'Verificado exitosamente',
    verifyTip: '¡Obtenga financiación instantánea para proteger sus inversiones!',
  },
  login: {
    btnContinueFacebook: 'Continuar con Facebook',
    btnContinueGoogle: 'Continuar con Google',
    btnLogin: 'Iniciar sesión',
    btnLoginFacebook: 'Ingresar con Facebook',
    btnLoginGoogle: 'Ingresar con Google',
    btnNext: 'Siguiente',
    btnRecovery: 'Recuperación',
    btnRecoveryPsd: 'Recuperar contraseña',
    btnRegister: 'Registrarse',
    btnRegisterFacebook: 'Registrarse con Facebook',
    btnRegisterGoogle: 'Registrarse con Google',
    btnSend: 'Enviar',
    btnSignup: 'Registrarse con correo electrónico',
    email: 'Correo electrónico',
    emailPlaceholder: 'Introduzca el correo, p. ej. name@example.com',
    emailTips: 'Este correo electrónico ya está registrado.',
    hasAccount: '¿Ya tienes una cuenta?',
    hasNotAccount: '¿No tienes una cuenta?',
    inputCode: 'Por favor, ingrese el código de verificación',
    inputEmail: 'Por favor, ingrese el correo electrónico',
    inputPassword: 'Por favor, ingrese la contraseña',
    inputPhone: 'Por favor, ingrese el correo electrónico',
    inputUsernameOrEmail: 'Introduzca usuario o correo',
    labelEmail: 'Correo electrónico:',
    labelEmailCode: 'Código de verificación:',
    labelPsd: 'Contraseña:',
    labelPsdNew: 'Nueva contraseña:',
    labelPsdRepeat: 'Confirmar contraseña:',
    labelUsername: 'Nombre de usuario:',
    labelUsernameOrEmail: 'Usuario o correo:',
    phone: 'Correo:',
    phoneTips: 'Esta dirección de correo electrónico ha sido registrada.',
    starLogin: '¡Empecemos con el inicio de sesión!',
    starRegist: '¡Empecemos con el registro!',
    starReset: '¡Recuperemos la cuenta mediante correo electrónico!',
    tipRegisterContent:
      'Complete su registro y desbloquee la puerta de entrada a un mundo de emocionantes oportunidades de inversión, allanando el camino para el éxito financiero y el crecimiento.',
    tipRegisterTitle: '¡Regístrese y comience su próspero viaje de inversión!',
    useEmailRegister: 'Registrarse con correo electrónico',
    usePhoneRegister: 'Registrarse con número de teléfono',
    username: 'nombre de usuario',
    usernameOptional: 'Usuario (opcional; vacío = correo)',
    usernameTips: '¡Este nombre de usuario ya existe!',
    welcome: 'Bienvenido a',
  },
  navBottom: {
    bottomCompany: 'Compañía',
    bottomCompanyItem1: 'Sobre nosotros',
    bottomCompanyItem2: 'Supervisión de licencias',
    bottomCompanyItem3: 'Centro de ayuda',
    bottomCompanyItem4: 'Soporte en línea',
    bottomOther: 'Declaraciones',
    bottomOtherItem1: 'Información legal',
    bottomOtherItem2: 'Exclusión de responsabilidad',
    bottomOtherItem3: 'Advertencia de riesgo',
    bottomOtherItem4: 'Política de cookies',
    bottomOtherItem5: 'Acerca de la publicidad',
    bottomPolicy: 'Políticas',
    bottomPolicyItem1: 'Términos y condiciones',
    bottomPolicyItem2: 'Política de privacidad',
    bottomProduct: 'Productos',
    bottomProductItem1: 'Mercados',
    bottomProductItem2: 'Inversión y préstamos',
    bottomProductItem3: 'NFT solidarios',
    bottomProductItem4: 'Trading inteligente',
  },
  navTab: {
    btnLogin: 'Iniciar sesión',
    btnSignup: 'Registrarse',
    language: 'Idioma',
    languageTips: 'Elige un idioma y región',
    tabMenu1: 'Inicio',
    tabMenu2: 'Mercado',
    tabMenu3: 'Trading inteligente',
    tabMenu4: 'Préstamos',
    tabMenu5: 'NFTs',
    tabMenu6: 'Cuenta',
  },
  ninShuRuDeZhiSunJiaGeBuHeLi: 'El precio de stop loss que ingresó no es razonable',
  ninShuRuDeZhiYingJiaGeBuHeLi: 'El precio de toma de ganancias que ingresó no es razonable',
  ntfs: {
    Address: 'Dirección',
    AllMoneyCharities:
      'Todo el dinero obtenido de la venta de NFTs se dona a organizaciones benéficas de UNICEF',
    BuyNFT: '¡Compra arte NFT y ayuda a niños en todo el mundo!',
    BuyNow: 'Comprar',
    Chain: 'Cadena',
    Confirm: 'Confirmar',
    Creator: 'Creador',
    CumulativeDonation: 'Donación acumulada',
    CurrentBid: 'Oferta actual',
    Markets: 'Mercados',
    MyNFTs: 'Mis NFTs',
    NFTs: 'NFTs',
    NFTsDetail: 'Detalles del NFT',
    PlaceABid: 'Realizar una oferta',
    RemainingTime: 'Tiempo restante',
    Successful: 'Éxito',
    ThanksDonation: 'Gracias por tu donación',
    Thisaddress: 'Este artículo se enviará a tu dirección de monedero',
    Verified: 'Verificado',
    andUNICEF: 'y el dinero se donará a UNICEF',
    charity: 'caridad',
  },
  null: 'error desconocido',
  qingQieHuanWeiZhenShiZhangHuCaoZuo: 'Cambie a la operación de cuenta real',
  qingShangChuanPingZheng: 'Por favor cargue el certificado',
  qingShuRuDiZhi: 'Por favor ingrese la dirección',
  qingShuRuShouJiHao: 'por favor ingrese su correo electrónico',
  qingShuRuTouZiJinE: 'Por favor ingrese el monto de la inversión',
  qingShuRuYanZhengMa: 'por favor ingrese el código de verificación',
  qingShuRuZhengQueDeJinE: 'Por favor ingresa la cantidad correcta',
  qingShuRuZhengQueDeYouXiang: 'por favor ingrese su correo electrónico válido',
  qingShuRuZhiSunJiaGe: 'Por favor introduzca el precio del stop loss',
  qingShuRuZhiYingJiaGe: 'Por favor ingrese el precio de toma de ganancias',
  qingTianXieWanZhengXinXi: 'Por favor complete la información completa',
  qingZaiCiShuRuMiMa: 'Por favor ingrese la contraseña nuevamente',
  queRenMiMa: 'confirmar Contraseña',
  repaySuccess: 'Reembolso exitoso',
  ri: 'día',
  riLiShuai: 'Tasa de interés diaria:',
  search: {
    SearchHere: 'Buscar aquí',
  },
  shangChuanShiBaiQingZhongShi: 'La carga falló, por favor inténtalo de nuevo.',
  shenHeBuTongGuo: 'Auditoría no superada',
  shou: 'recibir',
  shouJiHao: 'Correo',
  shouXuFeiShiJiDaoZhangJinE: 'Tarifa de gestión/monto real recibido',
  shouYiZhong: 'Ingreso',
  shouYiZhuangTai: 'estado de ingresos',
  shuRuNinDeDianHuaHaoMa: 'Ingrese su número telefónico...',
  souSuo: 'buscar...',
  tiJiaoChengGong: 'Enviado satisfactoriamente',
  tiJiaoChongZhiPingZheng: 'Enviar bono de recarga',
  tiKuanFangShi: 'método de retiro',
  tiXian: 'retirar',
  tiXianDiZhi: 'dirección de retiro',
  tiXianShiJian: 'tiempo de retiro',
  tiXianXuYao_3DeShouXuFeiXuYaoWangLuoJieDianQueRenHouCaiNengRuZhangQingBuYaoJiangJiaMiHuoBiZhuanGeiMoShengRen:
    'El retiro requiere una tarifa de gestión del {rate}%, que requiere la confirmación del nodo de red antes de poder depositarse en la cuenta. No transfiera criptomonedas a extraños.',
  toast: {
    UnreasonablePriceProfitLoss:
      'Configuración de precios irrazonable para la toma de beneficios y la pérdida de detención',
    buyNumbers: 'por favor ingrese la cantidad de compra',
    copyError: 'error al copiar',
    copySuccess: '¡copia exitosa!',
    email: 'por favor ingrese su correo electrónico',
    inputAll: 'los datos ingresados no están completos',
    logOut: 'cerrar sesión',
    noData: 'no hay más datos',
    notAddress: 'por favor ingrese la dirección',
    notAmount: 'por favor ingrese la cantidad',
    notEmail: 'el formato del correo electrónico es incorrecto',
    notImage: 'el formato de imagen es incorrecto',
    notLoanAmount: 'por favor ingrese la cantidad del préstamo',
    notSigned: 'No firmado',
    notSmartAmount: 'por favor ingrese la cantidad inteligente',
    notSupportMedia: 'no se admite el acceso a los medios del usuario',
    notVerify: 'por favor realice la certificación KYC',
    notWithdrawAmount: 'por favor ingrese la cantidad a retirar',
    nothingfound: '¡todavía no se ha encontrado nada!',
    password: 'por favor ingrese su contraseña',
    passwordNotSame: 'las contraseñas ingresadas no son iguales',
    passwordRepeat: 'por favor confirme su contraseña',
    uploadImage: 'por favor cargue la imagen requerida',
    userName: 'por favor ingrese su nombre de usuario',
  },
  tongChangXuYaoNinDeShouJiHaoYongHuMingMiMaDengJiBenXinXiYouShiHuanXuYaoGeRenXinXiHeLianXiXinXi:
    'Por lo general, se requiere información básica como su correo electrónico, nombre de usuario, contraseña y, a veces, información personal e información de contacto.',
  touZiShiJian: 'tiempo de inversión',
  touZiZhouQi: 'ciclo de inversión',
  tuPianDaXiaoBuNengChaoGuo_2mb: '¡El tamaño de la imagen no puede exceder los 2 MB!',
  tuPianDaXiaoBuNengChaoGuo_5m: '¡El tamaño de la imagen no puede exceder los 50 MB!',
  uploadfailed: 'subida fallida',
  usdtZuiDiChongZhiJinewei_120: 'El monto mínimo de depósito de {name} es {limit}',
  waiHuiZiDongJiaoYiLiangHuaShiYiZhongLiYongJiSuanJiChengXuHeSuanFaZiDongZhiHangJiaoYiCeLveDeFangFaGaiFangFaShiYongLiShiShuJuJiShuZhiBiaoTongJiMoXingHeQiTaFenXiGongJuLaiShiBieJiaoYiXinHaoBingZaiZhiHangJiaoYiShiZiDongZhiHangZheXieXinHaoWaiHuiZiDongJiaoYiLiangHuaKeYiBangZhuJiaoYiZheXiaoChuQingXuYingXiangJianShaoCuoWuJiaoYiTiGaoJiaoYiXiaoShuaiHeYiZhiXingDanShiZiDongWaiHuiJiaoYiLiangHuaYeCunZaiYiXieQianZaiDeFengXianHeJuXianXingLiRuZiDongJiaoYiChengXuKeNengWuFaShiYingShiChangBianHuaJiaoYiChengXuHeSuanFaDeZhiLiangHeYouXiaoXingZaiHenDaChengDuShangQuJueYuLiShiShuJuDeKeKaoXingHeYouXiaoXingCiWaiZiDongJiaoYiHuanKeNengCunZaiJiShuFengXianRuDianNaoGuZhangWangLuoZhongDuanDengYinCiZaiShiYongWaiHuiZiDongJiaoYiLiangHuaQianTouZiZheXuYaoZiXiPingGuZiJiDeJiaoYiMuBiaoFengXianChengShouNengLiHeJiShuNengLiXuanZeKeKaoDeJiaoYiPingTaiJiaoYiPingTaiHeZiDongJiaoYiChengXuZuiZhongYaoDeShiTouZiZheYingShiZhongBaoChiJinShenBingCaiQuShiDangDeFengXianGuanLiCuoShiLaiBaoHuTaMenDeTouZi:
    'La cuantificación automática de las operaciones de Forex es un método que utiliza programas y algoritmos informáticos para ejecutar automáticamente estrategias comerciales. \nEste método utiliza datos históricos, indicadores técnicos, modelos estadísticos y otras herramientas analíticas para identificar señales comerciales y ejecutarlas automáticamente al ejecutar operaciones. \nLa cuantificación automatizada de las operaciones de Forex puede ayudar a los operadores a eliminar el impacto de las emociones, reducir las transacciones erróneas y mejorar la eficiencia y coherencia de las transacciones. \nSin embargo, la cuantificación automatizada del comercio de divisas también tiene algunos riesgos y limitaciones potenciales. \nPor ejemplo, es posible que los programas comerciales automatizados no puedan adaptarse a los cambios del mercado, y la calidad y eficacia de los programas y algoritmos comerciales dependen en gran medida de la confiabilidad y validez de los datos históricos. \nAdemás, el comercio automático también puede implicar riesgos técnicos, como fallas informáticas, interrupciones de la red, etc. Por lo tanto, antes de utilizar la cuantificación automatizada del comercio de divisas, los inversores deben evaluar cuidadosamente sus objetivos comerciales, su tolerancia al riesgo y sus capacidades técnicas, y elegir un sistema confiable. plataforma de negocios . \nPlataformas comerciales y programas comerciales automatizados. \nLo más importante es que los inversores siempre deben actuar con cautela y tomar medidas adecuadas de gestión de riesgos para proteger sus inversiones.',
  wallet: {
    activate: 'Activar',
    authFailed: 'Autorización fallida',
    authSuccess: 'Autorización exitosa',
    authorized: 'Autorizado',
    connectFailed: 'Error al conectar la billetera',
    connectWallet: 'Conectar billetera',
    connecting: 'Conectando...',
    justCanWallet: 'Este sitio web solo acepta acceso desde Dapps descentralizadas',
    networkNotSupported: 'La red actual no es compatible, por favor cambia a una red compatible',
    noWalletDetected: 'No se detectó ninguna billetera. Por favor instala MetaMask o TronLink.',
    pleaseConnectWallet: 'Por favor conecta tu billetera',
    status: 'Estado de la billetera',
    testnetDisabled: 'La red de pruebas está deshabilitada, por favor usa la red principal',
    transactionCancelled: 'Transacción cancelada',
    unauthorized: 'No autorizado',
    userCancelled: 'El usuario canceló la operación',
  },
  wangLuoChaoShiQingQuDingDanLieBiaoChaKanGaiDingDan:
    'Tiempo de espera de la red, vaya a la lista de pedidos para ver el pedido',
  weiKaiQiZhiNengJiaoYi: 'El comercio inteligente no está habilitado',
  weiRenZheng: 'no certificado',
  weiShiMoWoXuYaoZhuCeYiGeZhangHu: '¿Por qué necesito registrarme para obtener una cuenta?',
  weiTongGuo: 'No pasó',
  woDeZhuCeXinXiHuiBeiBaoMiMa: '¿Mi información de registro se mantendrá confidencial?',
  woKeYiGengGaiWoDeZhuCeXinXiMa: '¿Puedo cambiar mi información de registro?',
  woKeYiZhuCeDuoGeZhangHuMa: '¿Puedo registrar varias cuentas?',
  xiaCiShouYiShiJian: 'Próximo momento de ganancias',
  xiaDanChengGong: 'ordenado exitosamente',
  xinGongNengShangXian: '¡Nuevas funciones están en línea!',
  xinMiMa: 'Nueva contraseña',
  yanShiZhangHaoBuNengShiYongGaiGongNeng: 'Las cuentas demo no pueden utilizar esta función',
  yanShiZhangHuBuNengShiYongZhiNengJiaoYi:
    'Las cuentas demo no pueden utilizar el comercio inteligente',
  yanShiZhangHuYiJinYong: 'Cuenta demo deshabilitada',
  yiDaoQi: 'estar caducado',
  yiFenRun: 'El beneficio se ha dividido',
  yiFenRunTianShu: 'Número de días de participación en las utilidades',
  yiHuanKuan: 'reembolsado',
  yiJuJue: 'rechazado',
  yiQieHuanWeiXuNiZhangHu: 'Cambiado a cuenta virtual',
  yiQieHuanWeiZhenShiZhangHu: 'Cambiado a cuenta real',
  yiRenZheng: 'verificado',
  yiWanCheng: 'terminado',
  yiXieWangZhanKeNengYunXuYongHuZhuCeDuoGeZhangHuDanDaDuoShuWangZhanZhiYunXuMeiGeYongHuZhuCeYiGeZhangHuRuGuoNinChangShiZhuCeDuoGeZhangHuNinDeZhangHuKeNengHuiBeiJinZhiHuoShanChu:
    'Algunos sitios web pueden permitir a los usuarios registrar varias cuentas, pero la mayoría de los sitios web solo permiten que cada usuario registre una cuenta. \nSi intenta registrar varias cuentas, es posible que su cuenta sea prohibida o eliminada.',
  zhangFu: 'Aumentar',
  zhenFu: 'amplitud',
  zhuCeChengGong: 'registración exitosa',
  zhuCeZhangHuKeYiRangNinGengFangBianDiShiYongWangZhanHuoYingYongChengXuDeGongNengBingKeYiBaoHuNinDeGeRenXinXi:
    'Registrar una cuenta le permite utilizar las funciones del Sitio o la Aplicación de manera más conveniente y protege su información personal.',
  zhuCeZhangHuXuYaoShiMoXinXi: '¿Qué información se necesita para registrar una cuenta?',
  zongLiXi: 'interés total',
  zuiDiJia: 'el precio más bajo',
}
